import { rei } from "@/services/api"

class RecibosService {
  static reciboObito (params = null) {
    const options = {
      responseType: 'arraybuffer'
    }

    return rei.post(`impressao/recibo/obito`, { ...params }, options)
      .then(response => {
        let blob = new Blob([response.data], { type: 'application/pdf' })
        let url = window.URL.createObjectURL(blob)

        return url
      })
  }

  static reciboNascimento (params = null) {
    const options = {
      responseType: 'arraybuffer'
    }

    return rei.post(`impressao/recibo/nascimento`, { ...params }, options)
      .then(response => {
        let blob = new Blob([response.data], { type: 'application/pdf' })
        let url = window.URL.createObjectURL(blob)

        return url
      })
  }

  static reciboCasamento (params = null) {
    const options = {
      responseType: 'arraybuffer'
    }

    return rei.post(`impressao/recibo/casamento`, { ...params }, options)
      .then(response => {
        let blob = new Blob([response.data], { type: 'application/pdf' })
        let url = window.URL.createObjectURL(blob)

        return url
      })
  }

  static reciboSemRegistro (params = null) {
    const options = {
      responseType: 'arraybuffer'
    }

    return rei.post('impressao/recibo/sem-registro', { ...params }, options)
      .then(response => {
        let blob = new Blob([response.data], { type: 'application/pdf' })
        let url = window.URL.createObjectURL(blob)

        return url
      })
  }
}

export default RecibosService
